import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/utils/cn";

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {
  label?: string;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, ...props }, ref) => {
    return (
      <label className="flex items-center gap-2 cursor-pointer select-none text-sm text-gray-700">
        <div
          className={cn(
            "relative flex items-center justify-center w-4 h-4 border border-gray-400 rounded-sm transition-colors duration-150",
            "focus-within:ring-2 focus-within:ring-[#7b2a40]/40",
            "checked:border-[#7b2a40]",
            className
          )}
        >
          <input
            ref={ref}
            type="checkbox"
            className="appearance-none absolute w-full h-full cursor-pointer peer rounded-sm"
            {...props}
          />
          <Check
            className={cn(
              "w-3 h-3 text-[#7b2a40] opacity-0 transition-opacity peer-checked:opacity-100"
            )}
          />
        </div>
        {label && <span>{label}</span>}
      </label>
    );
  }
);

Checkbox.displayName = "Checkbox";

export { Checkbox };
